import {Component, Injector} from "@angular/core";
import {RoutesDialogBaseComponent} from "./routes-dialog-base/routes-dialog-base.component";

@Component({
    selector: 'app-edit-route',
    templateUrl: './routes-dialog-base/routes-dialog-base.component.html',
    styleUrls: ['./routes-dialog-base/routes-dialog-base.component.css'],
    standalone: false
})
export class EditRoutesComponent extends RoutesDialogBaseComponent {

  constructor(protected injector:Injector) {
    super(injector);
    this.dialogId = "createRoute";
  }

  public submit() {
    this.routesService.EditRoute(this.model)
      .subscribe((res) => {
          this.onCreated.emit();
          this.close();
          super.submit();
        });
  }
}
